import matchSorter from 'match-sorter';
export default function getItems(allItems, filterValue) {
    return filterValue
        ? matchSorter(allItems, filterValue, {
            keys: ['label'],
        })
        : allItems;
}
//# sourceMappingURL=getItems.js.map